import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => ({
	prompt: {
		marginBottom: theme.spacing(2),
	},
	table: {
		border: `1px solid ${theme.palette.custom.borderCard}`,
		borderRadius: 8,
		marginBottom: theme.spacing(2),
		"& th": {
			fontSize: 12,
			paddingTop: theme.spacing(1),
			paddingBottom: theme.spacing(1),
			color: theme.palette.custom.textSecondary,
		},
		"& tbody tr": {
			cursor: "pointer",
		},
	},
	hint: {
		color: theme.palette.custom.textSecondary,
	},
	pick: {
		fontWeight: 700,
		whiteSpace: "nowrap",
	},
	leading: {
		marginRight: "auto",
	},
} satisfies Record<string, CSSObject>);
